/**
 * Rapor sekmesi — Blazor `OnOpenReportInTab` (GridComponent.RaporIslemiClick) karşılığı.
 *
 * Rapor işlemindeki `ShowDialog` raporun NEREDE açılacağını söyler:
 *   true  → mevcut ekranın üstünde popup
 *   false → yeni sekme
 * Blazor'da bu ayrım yalnızca web'de (AppId = "Octo.Web") yapılır; mobil her zaman popup
 * açar. Modal içindeyken de popup'a düşülür, çünkü sekme açacak taraf orada yoktur.
 */
import { useTabsStore } from '@/features/shell/tabs/tabsStore';
import type { OpenTabOptions } from '@/features/shell/tabs/model/types';

export const REPORT_TAB_TYPE = 'report';

export interface ReportTabParams {
  /** Rapor işlemi kimliği; SP tetiklemesinde yerine reportId gelir. */
  reportActionId?: string | null;
  reportId?: string | null;
  /** `{"Alan": değer}` JSON'u (boş olabilir) */
  filterValue: string;
  reportName: string;
  zoom?: number | null;
  [key: string]: unknown;
}

export function openReportTab(params: ReportTabParams, opts?: OpenTabOptions) {
  const id = params.reportActionId || params.reportId || '';
  // Aynı rapor aynı parametrelerle ikinci kez açılmaz; farklı parametre yeni sekme demektir
  // (Blazor'da da başlık parametreyi taşır, iki farklı sonuç aynı sekmeye sığmaz).
  const uniqueKey = `report:${id}:${params.filterValue || ''}`;
  return useTabsStore.getState().openCustom({
    kind: 'custom',
    screenTypeName: REPORT_TAB_TYPE,
    caption: params.reportName,
    params,
    uniqueKey,
  }, opts);
}

/** Rapor tasarımcısı sekmesinin ekran tipi — ScreenHost bu adla eşleştiriyor. */
export const REPORT_DESIGNER_TAB_TYPE = 'reportdesigner';

/**
 * Rapor tasarımcısını sekmede açar (ActionTypeId = Rapor Tasarımcısı olan veri işlemi).
 * Aynı rapor ikinci kez açılmaz; tasarımcı ağır ve iki kopya aynı şablonu kaydetmeye
 * çalışırsa biri diğerinin değişikliğini eziyor.
 */
export function openReportDesignerTab(reportId: string, reportName?: string, opts?: OpenTabOptions) {
  return useTabsStore.getState().openCustom({
    kind: 'reportDesigner',
    screenTypeName: REPORT_DESIGNER_TAB_TYPE,
    caption: reportName || 'Rapor Tasarımcısı',
    params: { reportId },
    uniqueKey: `reportDesigner:${reportId}`,
  }, opts);
}
